import { DateTime } from 'luxon';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { useCampaignModuleContext } from '../../context';
import useCampaignsOptions from '../../hooks/useCampaignsOptions';
import { CampaignListItem } from '../../types';

const StyledLink = styled(Link)`
  font-weight: 500;
`;

const CampaignOverlapAlertMessage = ({
  parallelVenueCampaigns,
  parallelCampaignsAlertId,
  venueId,
}: {
  parallelVenueCampaigns: CampaignListItem[];
  parallelCampaignsAlertId: string;
  venueId: string;
}) => {
  const { timezone } = useCampaignModuleContext();
  const { locale } = useIntl();
  const { getCampaignTitleByType } = useCampaignsOptions();
  const [singleCampaign] = parallelVenueCampaigns;

  return (
    <FormattedMessage
      id={parallelCampaignsAlertId}
      values={{
        campaignType: getCampaignTitleByType(singleCampaign.campaignType),
        startDate: DateTime.fromISO(singleCampaign.startDate)
          .setZone(timezone)
          .toLocaleString(DateTime.DATE_SHORT, { locale }),
        endDate: singleCampaign.endDate
          ? DateTime.fromISO(singleCampaign.endDate).setZone(timezone).toLocaleString(DateTime.DATE_SHORT, { locale })
          : '-',
        CampaignLink: (text: string) => (
          <StyledLink to={`/venue/${venueId}/campaigns/${singleCampaign.campaignId}`} target="_blank">
            {text}
          </StyledLink>
        ),
        AllCampaignsLink: (text: string) => (
          <StyledLink to={`/venue/${venueId}/campaigns`} target="_blank">
            {text}
          </StyledLink>
        ),
      }}
    />
  );
};

export default CampaignOverlapAlertMessage;
